import React from "react";
import { NavLink } from "react-router-dom";
export const NavbarBackHome = () => {
    return (React.createElement("div", { className: "navbar" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "navbar-inner" },
                React.createElement(NavLink, { to: "/cs/seznam/nejblizsi-aukce", className: "back-link" },
                    React.createElement("span", { className: "icon", "aria-hidden": true }),
                    React.createElement("span", { className: "text" }, "Zp\u011Bt na \u00FAvodn\u00ED stranu"))))));
};
